import { useState } from "react";
import {
  Grid,
  Button,
  TextField,
  Dialog,
  DialogContent,
  DialogActions,
  CardHeader,
} from "../../../../components";
import { value } from "../../../../helpers";
import { responseErros } from "../../../../utils";
import {
  SessionService,
  PdvOfflineService,
  SincService,
} from "../../../../services";

const sincService = new SincService();
const sessionService = new SessionService();
const pdvOfflineService = new PdvOfflineService();

const NomePdvOfflineDialog = ({
  openDialogNomePdvOffline,
  setOpenDialogNomePdvOffline,
  setLoading,
  startSincronizacaoInicialOffline,
}) => {
  const [nomePdv, setNomePdv] = useState(null);
  const [erroNome, setErroNome] = useState(false);

  const handleInputChange = (e) => {
    e.persist();
    setNomePdv(e.target.value);
  };

  const handleFecharCaixa = async () => {
    if (!nomePdv) {
      setErroNome(true);
      return;
    }
    setLoading(true);
    const response = await pdvOfflineService.cadastrar({ nome: nomePdv });
    if (!response.isAxiosError) {
      await sincService.sincronizar();
      setLoading(false);
      setOpenDialogNomePdvOffline(false);
      sessionService.setNomePdvOffline(nomePdv);
      setErroNome(false);
      startSincronizacaoInicialOffline();
    } else {
      setLoading(false);
      responseErros(response);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialogNomePdvOffline(false);
  };

  return (
    <Dialog
      maxWidth={"xs"}
      fullWidth
      open={openDialogNomePdvOffline}
      onClose={handleCloseDialog}
    >
      <DialogContent>
        <CardHeader title="Nome de identificação do PDV Offline" />
        <Grid container>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label="Nome do PDV"
              id="nomePdvOffline"
              name="nomePdvOffline"
              margin="dense"
              type="text"
              fullWidth
              onChange={(event) => handleInputChange(event)}
              value={value.text(nomePdv)}
              error={erroNome}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          color="info"
          size="large"
          variant="contained"
          onClick={handleFecharCaixa}
          disableElevation
          fullWidth
        >
          <i
            className="ph-fill ph-check-circle"
            style={{ fontSize: 22, marginRight: 10, color: "white" }}
          ></i>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NomePdvOfflineDialog;
